import ExamCard from "./ExamCard";

const ExamList = ({ exams, subscriptions }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
      {exams.map((exam) => (
        <ExamCard key={exam._id} exam={exam} subscriptions={subscriptions} />
      ))}
    </div>
  );
};

export default ExamList;
